import React, { useState, useContext } from 'react'
import { Input, Form, Button, message } from 'antd'
import { ErpClientContext } from '../../services/erp'

export function OpinionForm({
  opinion,
  id_opinion,
  shop,
  titulo,
  nota,
  nombre_usuario,
  estado,
  data,
  setData,
  initialData,
  statusTab,
}) {
  const erpService = useContext(ErpClientContext)
  const [form] = Form.useForm()
  const [status, setStatus] = useState()
  const disabled = status === 'Managing'

  async function onSave() {
    let saved = false

    setStatus('Managing')
    try {
      const values = await form.validateFields()
      await erpService.editOpinion(
        id_opinion,
        values.opinion,
        values.titulo,
        values.nombre_usuario,
        values.nota,
        estado,
        shop
      )
      saved = true
      message.success('Opinion saved.')
    } catch (errorInfo) {
      console.log(errorInfo)
      message.error('Opinion could not be saved.')
    }
    setStatus(null)

    return saved
  }

  async function onPublish() {
    if (window.confirm('Are you sure you want to publish this opinion?')) {
      setStatus('Managing')
      try {
        const saved = await onSave()
        if (!saved) throw new Error('No se ha guardado')
        await erpService.publishOpinion(id_opinion, shop)
        setData(data.filter((op) => op.id_opinion !== id_opinion))
        initialData.current = initialData.current.filter(
          (op) => op.id_opinion !== id_opinion
        )
        message.success('Opinion published!')
      } catch (errorInfo) {
        console.log(errorInfo)
        message.error('Opinion could not be published')
      }
      setStatus(null)
    }
  }

  async function onRefuse() {
    if (window.confirm('Are you sure you want to reject this opinion?')) {
      setStatus('Managing')
      try {
        await erpService.refuseOpinion(id_opinion, shop)
        setData(data.filter((op) => op.id_opinion !== id_opinion))
        initialData.current = initialData.current.filter(
          (op) => op.id_opinion !== id_opinion
        )
        message.success('Opinion rejected!')
      } catch (errorInfo) {
        message.error('Opinion could not be rejected.')
      }
      setStatus(null)
    }
  }

  async function backToPending() {
    setStatus('Managing')
    try {
      await erpService.editOpinion(
        id_opinion,
        opinion,
        titulo,
        nombre_usuario,
        nota,
        'pend',
        shop
      )
      setData(data.filter((op) => op.id_opinion !== id_opinion))
      initialData.current = initialData.current.filter(
        (op) => op.id_opinion !== id_opinion
      )
      message.success('Opinion back to pending.')
    } catch (errorInfo) {
      message.error('Opinion could not be modified.')
    }
    setStatus(null)
  }

  return (
    <Form form={form} initialValues={{ opinion, titulo, nota, nombre_usuario }}>
      <Form.Item
        name="titulo"
        label="Title"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input type="text" />
      </Form.Item>
      <Form.Item
        name="nombre_usuario"
        label="Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input type="text" />
      </Form.Item>
      <Form.Item
        name="nota"
        label="Rate"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input type="number" />
      </Form.Item>
      <Form.Item
        name="opinion"
        label="Review"
        rules={[
          {
            required: true,
            min: 50,
            max: 600,
          },
        ]}
      >
        <Input.TextArea rows={6} />
      </Form.Item>
      <div className="controls">
        {statusTab === 'pend' && (
          <>
            <Button onClick={onRefuse} disabled={disabled}>
              Refuse
            </Button>
            <Button onClick={onSave} disabled={disabled}>
              Save
            </Button>
            <Button type="primary" onClick={onPublish} disabled={disabled}>
              Save and Publish
            </Button>
          </>
        )}
        {statusTab !== 'pend' && (
          <Button onClick={backToPending} disabled={disabled}>
            Back to pending
          </Button>
        )}
      </div>
    </Form>
  )
}
